export const LogItMixin = {
    methods: {
        logit(x) {
            console.log('!! LOG IT !!')
            console.log(x)
        },
    }
}